import React from 'react';
import { useTranslations } from 'components/utilities';
import { EN, AR } from 'helpers';
import { Button } from '@material-ui/core';
import { useStyles } from '../styles';

const LanguageSwitcher = () => {
	const { i18n } = useTranslations();
	const classes = useStyles();
	const isEnglish = i18n.language === EN;
	const nextLanguage = isEnglish ? AR : EN;

	const handleChangeLanguage = () => {
		i18n.changeLanguage(nextLanguage);
	};

	return (
		<Button
			className={classes.headerBtn}
			onClick={handleChangeLanguage}
			variant="contained"
			color="primary"
		>
			{isEnglish ? 'عربي' : 'EN'}
		</Button>
	);
};

export default LanguageSwitcher;
